export interface CodedProperty {
    id: string;
    name: string;
    code: string;
}

export const defaultCodedProperty: CodedProperty = { id: "", name: "", code: "" };
